import moment from 'moment-timezone';

function pad2(value) {
    return String(value).padStart(2, '0');
}

export function getPointMoment(pointTime) {
    if (!pointTime) {
        return moment();
    }

    let parsed;

    if (pointTime.epoch != null && pointTime.epoch !== '') {
        parsed = moment.unix(Number(pointTime.epoch));
    } else {
        const year = pointTime.YEAR ?? pointTime.YYYY;
        const month = pointTime.MONTH ?? pointTime.MM;
        const day = pointTime.DAY ?? pointTime.DD;
        const hour = pointTime.HOUR ?? pointTime.hh;
        const minute = pointTime.MINUTE ?? pointTime.mm;
        const second = pointTime.SECOND ?? pointTime.ss;
        const dateStr = `${year}-${pad2(month)}-${pad2(day)} ${pad2(hour)}:${pad2(minute)}:${pad2(second)}`;
        parsed = moment.utc(dateStr, 'YYYY-MM-DD HH:mm:ss').local();
    }

    const now = moment();
    return parsed.isAfter(now) ? now.clone() : parsed;
}
